import Vue from 'vue'
import infinityTooltip from '../directives/infinity-tooltip'
import InfinityPopover from '../components/layout/InfinityPopover.vue'

export default {
  install: function (vue: typeof Vue) {
    vue.directive('infinity-tooltip', infinityTooltip)
    vue.component('infinity-popover', InfinityPopover)
  }
}
